export default __webpack_public_path__ + "static/media/product-page-1.34b20db8.png";